import { render, staticRenderFns } from "./select.vue?vue&type=template&id=40fa6c1e&scoped=true"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"
import style0 from "./select.vue?vue&type=style&index=0&id=40fa6c1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fa6c1e",
  null
  
)

export default component.exports